import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BrandSignUp = () => {
  const [userdata, setuserdata] = useState({
    uname: "",
    shopName: "",
    brandType: "",
    phone: "",
    email: "",
    city: "",
    state: "",
    country: "",
    address: "",
    location: "",
    password: "",
    instagramUrl: "",
    facebookUrl: "",
  });

  const [cpass, setcpass] = useState("");
  const navigate = useNavigate();

  const handleInput = (e) => {
    const { name, value } = e.target;
    setuserdata({ ...userdata, [name]: value });
  };

  const handleConfirmPassword = (e) => {
    setcpass(e.target.value);
  };

  const postData = async (e) => {
    e.preventDefault();

    const {
      uname,
      shopName,
      brandType,
      phone,
      email,
      city,
      state,
      country,
      address,
      location,
      password,
      facebookUrl,
      instagramUrl,
    } = userdata;

    if (password !== cpass) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const res = await fetch(
        "https://server-side-influencer.onrender.com/brand/signup",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uname,
            shopName,
            brandType,
            phone,
            email,
            city,
            state,
            country,
            address,
            location,
            password,
            facebookUrl,
            instagramUrl,
          }),
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        toast.success(data.message);
        setTimeout(() => {
          navigate("/BrandLogin");
        }, 2000);
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error("An error occurred while submitting your data.");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center font-[sans-serif] bg-gradient-to-r from-purple-600 to-blue-500 min-h-screen p-6">
      <div className="grid md:grid-cols-2 bg-white max-w-7xl w-full shadow-lg rounded-xl overflow-hidden">

        {/* LEFT SECTION */}
        <div className="flex flex-col justify-center items-center p-10 bg-gradient-to-br from-purple-600 to-blue-500 text-center">

          {/* Logo + Text in ONE LINE */}
          <div className="flex items-center gap-3 mb-8">
            <img
              src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
              alt="Influenceso Logo"
              className="h-12 w-auto"
            />
            <h2 className="text-3xl font-extrabold text-white tracking-tight whitespace-nowrap">
              Influenceso
            </h2>
          </div>

          <h4 className="text-white text-4xl font-bold">
            Create Your Account
          </h4>

          <p className="text-lg text-white/90 mt-4 max-w-md">
            Welcome to Influenceso. Create your account and connect with top influencers.
          </p>
        </div>

        {/* RIGHT SIDE FORM */}
        <form
          className="p-8 w-full overflow-y-auto max-h-[85vh]"
          onSubmit={postData}
        >
          <div className="mb-10">
            <h3 className="text-3xl font-extrabold text-center md:text-left">
              Register As Brand
            </h3>
          </div>

          <div className="grid lg:grid-cols-2 gap-6">
            {[
              { label: "User Name", name: "uname" },
              { label: "Shop Name", name: "shopName" },
              { label: "Brand Type", name: "brandType" },
              { label: "Phone Number", name: "phone" },
              { label: "Email", name: "email" },
              { label: "City", name: "city" },
              { label: "State", name: "state" },
              { label: "Country", name: "country" },
              { label: "Address", name: "address" },
              { label: "Location", name: "location" },
              { label: "Instagram URL", name: "instagramUrl" },
              { label: "Facebook URL", name: "facebookUrl" },
            ].map(({ label, name }) => (
              <div key={name}>
                <label className="text-gray-700 text-sm mb-1 block">
                  {label}
                </label>
                <input
                  name={name}
                  type="text"
                  className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-purple-500 focus:bg-white"
                  placeholder={`Enter ${label.toLowerCase()}`}
                  value={userdata[name]}
                  onChange={handleInput}
                />
              </div>
            ))}

            <div>
              <label className="text-gray-700 text-sm mb-1 block">
                Password
              </label>
              <input
                name="password"
                type="password"
                className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-purple-500 focus:bg-white"
                placeholder="Enter password"
                value={userdata.password}
                onChange={handleInput}
              />
            </div>

            <div>
              <label className="text-gray-700 text-sm mb-1 block">
                Confirm Password
              </label>
              <input
                type="password"
                className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-purple-500 focus:bg-white"
                placeholder="Confirm password"
                value={cpass}
                onChange={handleConfirmPassword}
              />
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <button
              type="submit"
              className="w-full sm:w-1/2 py-3 px-6 font-semibold rounded-md text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:scale-105 transition"
            >
              Register
            </button>
          </div>

          <div className="text-center mt-5">
            <p className="text-sm">
              Already have an account?{" "}
              <Link
                to="/BrandLogin"
                className="text-purple-600 font-semibold hover:underline"
              >
                Login
              </Link>
            </p>
          </div>
        </form>
      </div>

      <ToastContainer />
    </div>
  );
};

export default BrandSignUp;